import { z } from "zod";
export const contactInfoSchema = z.object({
    address: z.string(),
    city: z.string(),
    contact_info_id: z.string(),
    country: z.string(),
    geo_location_lat: z.number().optional(),
    geo_location_long: z.number().optional(),
    phone_number: z.string().optional(),
    post_code: z.string(),
    state: z.string()
});
